import { BagFilled } from '@depop/web-thrift-ui/Illustrations/BagFilled';
import { Body, Heading } from '@depop/web-thrift-ui/Typography';
import { Panel } from '@depop/web-ui-kit/Panel';
import { clsx } from 'clsx';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { ButtonExperiment } from '@/components/ButtonExperiment';
import { ExtendedLink } from '@/components/ExtendedLink';
import { ActivityTrackerEventType } from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import { useSignup } from '@/modules/signup/hooks/useSignup';

type Props = {
  id: string;
  className?: string;
  isQuickAccess?: boolean;
};

export function BagSignupPrompt({
  id,
  className,
  isQuickAccess = false,
}: Props) {
  const t = useTranslations('bag');
  const { url: signupUrl } = useSignup();
  const { sendActivityTrackerEvent } = useActivityTracker();

  function handleSignupClick() {
    sendActivityTrackerEvent(ActivityTrackerEventType.CTA_ACTION, {
      type: isQuickAccess
        ? 'quick_bag_signup_prompt_cta'
        : 'bag_signup_prompt_cta',
    });
  }

  return (
    <Panel id={id} className={clsx(styles.signupPanel, className)}>
      <span
        className={clsx(
          styles.illustration,
          !isQuickAccess && styles.largeIllustration
        )}
      >
        <BagFilled size="xSmall" />
      </span>
      <div
        className={clsx(styles.mobileText, isQuickAccess && styles.smallText)}
      >
        <Heading variant="md" as="p">
          {t('Bag.SignUp.Title')}
        </Heading>
        <Body variant="sm-regular">{t('Bag.SignUp.Subtitle')}</Body>
      </div>
      <ExtendedLink
        href={signupUrl}
        className={styles.signupCta}
        onClick={handleSignupClick}
      >
        <ButtonExperiment size="small" type="button">
          {t('Bag.SignUp.Cta')}
        </ButtonExperiment>
      </ExtendedLink>
    </Panel>
  );
}
